import { render, staticRenderFns } from "./ViewAnnounceHr.vue?vue&type=template&id=4a625847&scoped=true&"
import script from "./ViewAnnounceHr.vue?vue&type=script&lang=js&"
export * from "./ViewAnnounceHr.vue?vue&type=script&lang=js&"
import style0 from "./ViewAnnounceHr.vue?vue&type=style&index=0&id=4a625847&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4a625847",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VCard } from 'vuetify/lib/components/VCard';
import { VCardSubtitle } from 'vuetify/lib/components/VCard';
import { VCardText } from 'vuetify/lib/components/VCard';
import { VCardTitle } from 'vuetify/lib/components/VCard';
import { VCarousel } from 'vuetify/lib/components/VCarousel';
import { VCarouselItem } from 'vuetify/lib/components/VCarousel';
import { VSheet } from 'vuetify/lib/components/VSheet';
installComponents(component, {VCard,VCardSubtitle,VCardText,VCardTitle,VCarousel,VCarouselItem,VSheet})
